import React from "react";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { LogoMarquee } from "../components/site/LogoMarquee";
import { Manifesto } from "../components/site/Manifesto";
import { Features } from "../components/site/Features";
import { Showcase } from "../components/site/Showcase";
import { RoiCalculator } from "../components/site/RoiCalculator";
import { Pricing } from "../components/site/Pricing";
import { Testimonials } from "../components/site/Testimonials";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <LogoMarquee />
        <Manifesto />
        <Features />
        <Showcase />
        <RoiCalculator />
        <Pricing />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}
